import { TooltipProps } from 'recharts';

import { BarChartTooltip, CustomBarchartTooltipProps } from './bar-chart-tooltip.component';
import { BarPieceItem } from './bar-chart.types';

export type BuildTooltipProps<T> = (
  params: TooltipProps<number, string> & {
    rawItem: T;
    totalValue: number;
  },
) => CustomBarchartTooltipProps;

export type BuildSelectedRangeTooltipPropsParams<T> = {
  items: BarPieceItem<T>[];
  selectedIndexes: number[];
  totalValue: number;
};

export type BuildSelectedRangeTooltipProps<T> = (
  params: BuildSelectedRangeTooltipPropsParams<T>,
) => CustomBarchartTooltipProps | null;

export const buildRenderTooltip =
  <T,>(
    selectedIndexes: number[],
    refAreaEndIndex: number | null,
    totalValue: number,
    buildTooltipProps: BuildTooltipProps<T>,
    buildSelectedRangeTooltipProps: BuildSelectedRangeTooltipProps<T> | undefined,
    items: BarPieceItem<T>[],
  ) =>
  ({ active, payload, label }: TooltipProps<number, string>) => {
    const selectedRangeTooltipProps: CustomBarchartTooltipProps | null =
      buildSelectedRangeTooltipProps
        ? buildSelectedRangeTooltipProps({
            items,
            selectedIndexes,
            totalValue,
          })
        : null;

    if (selectedIndexes.length === 0 && refAreaEndIndex === null) {
      if (!active || !payload || !payload.length) {
        return null;
      }

      const rawItem: T = payload[0].payload.rawItem as T;
      const { items }: CustomBarchartTooltipProps = buildTooltipProps({
        totalValue,
        active,
        payload,
        label,
        rawItem,
      });

      return <BarChartTooltip items={items} />;
    }

    if (selectedIndexes.length > 0 && selectedRangeTooltipProps) {
      if (!payload || !payload.length) {
        return null;
      }
      const name = payload[0].payload.name;
      const index = items.findIndex((item) => item.name === name);

      const isSelected = selectedIndexes.includes(index);
      if (!isSelected) {
        return null;
      }

      return <BarChartTooltip items={selectedRangeTooltipProps.items} />;
    }

    return null;
  };
